import React from "react";
import  { useState, useEffect } from 'react';
import './classes/SportsEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const ScoutEducationProgarm = () => {

    // const navigate = useNavigate();
    const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);
   const [conferences, setConferences] = useState([]);
   const [testimonialsData, setTestimonialsData] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Dan Evans",
                image: "/basic/web/images/scout/DSC_7438.jpg",
                description: `Former GM of the Los Angeles Dodgers, has been in professional baseball for over three decades, and has had decision-making roles with five MLB franchises throughout his career, including the White Sox (1981-2000), Chicago Cubs (2000-2001), Dodgers (2001-2004), Seattle Mariners (2004-2007), and the Toronto Blue Jays (2013-present). Evans’ experience is wide ranging, as he is the only former General Manager of a MLB club who also led a baseball agency. Evans has been a broadcast analyst for MLB games, is the author of “108 Stitches,” a column for Baseball Prospectus, and is a member of the Baseball Prospectus Advisory Board.`,
               
             },
             {
                name: "Ari Kaplan",
                image: "/basic/web/images/scout/picture-1955-1441814216.jpg",
                description: `Ari is one of the few long-term baseball leaders with a proven track record at Fortune&nbsp;500 companies, as well as successfully running several high-profile organizations as CEO or President. On the media front, Ari co-authored five best-selling books on analytics, databases, and baseball. Ari’s work has been profiled on CNN, Chris Matthews, and the Today Show and one of his high-profile analytics projects&nbsp;was&nbsp;turned into a documentary on the History Channel.`,
               
             },
             {
                name: "Larry D’Amato",
                image: "/basic/web/images/scout/larry.jpg",
                description: `has been scouting baseball for over 40 years. He started in 1970 as an&nbsp;area scout and held scouting positions as an&nbsp;Area Scout, Scouting Supervisor, National Cross Checker, Pro Scout, and Major League Scout for the Pittsburgh Pirates, Cincinnati Reds, New York Yankees, Major League Scouting Bureau, Texas Rangers and most recently the Houston Astros. The players he personally discovered and signed include Rod Scurry, Fred Breining, Jeff Lahti, Terry Lee, Jim Neidlinger, Steve Cooke. Larry has covered high schools, junior colleges, four year colleges, and the Pacific Coast League, Northwest League, Pioneer League. He has set up and run Free-Agent Tryout Camps all over the USA. He has covered both Arizona and Florida Major League Spring Training, in addition to the National League West, American League West, National League Central, American League East, International League and various Mexican Leagues. Larry is a three time winner of the Topps Scouting Award and he has 4 World Series Rings.`,
                
            },
        ];
        setMentors(mentors);

        const courseTopics = [
            "Sabermetrics",
            "Collegiate Baseball Scouting",
            "MLB Baseball Scouting",
            "Methods of ranking high-school and college baseball prospects",
            "The making of a baseball scouting report",
            "The language and history of baseball scouting",
            "Concise evaluation techniques and terminology",
            "New age scouting vs. Traditional methods",
            ];
        setCourseTopics(courseTopics);
 

   const conferences = [
        {
            title: "Baseball Career Conference",
            description:
            "Gain an in-depth insight into a variety of careers from those working at all levels in baseball including MLB and the minor leagues!",
            location: "Orlando, Florida",

            //  Desktop structure fields
            month: "December",
            day: "8",
            year: "2025",
            fullDate: "December 8, 2025", // for mobile layout

            image:
            "/basic/web/images/scout/DSC04825_1.png",
            icon:
            "/basic/web/images/scout/baseball.png",
            link: `${configData.DRUPAL_DOMAIN_URL}/winter-baseball-meetings-career-conference`,
        },
        

  // Add more conferences here...
];

    setConferences(conferences);

           const initialTestimonials  = [
        {
            id: 1,
            name: "Steve Wisensale, Ph.D.",
            title: "Professor, University of Connecticut-Storrs",
            image:
            "/basic/web/images/scout/picture-1938-1442595001.jpg",
            link: "/testimonial/steve-wisensale-phd",
            body: `As I near retirement I am attempting to make a smooth transition into baseball - either in management or scouting of some sort. The SMWW course on "Baseball GM and Scouting" was my first step toward converting stumbling blocks into stepping stones as I make a career transition.`
        }
        ];
   setTestimonialsData(initialTestimonials);

    },[]);

    useEffect(() => {
        Promise.all([
           
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
   
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="scout-sport-education-main">
                <Helmet><title>Baseball Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="sports-education-program-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW Baseball&nbsp;Education Program</h1>
                            <p>SMWW Baseball Scouts have been trained and mentored by some of the best in the industry. SMWW Baseball Scouts have completed a rigorous eight week training program and instructed by Dan Evans, Ari Kaplan&nbsp;and Larry D'Amato. SMWW Baseball Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the high school, university, or professional level.</p>
                            <h2>SMWW Baseball Scouting Mentors:</h2>
                             {mentors.map((mentor) => (
                                <div className="scout-mentors" key={mentor.name} style={{ marginBottom: "1.5rem", overflow: "auto" }}>
                                <img
                                    src={mentor.image}
                                    alt={mentor.name}
                                />
                                <p>
                                    <strong>{mentor.name}</strong> {mentor.description}
                                </p>
                                </div>
                            ))}
                            <h2>SMWW Baseball Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <a className="reddbtnn" href={`https://${configData.RSMWW_DOMAIN}/application`}>
                                Apply today for training as an SMWW Certified Baseball Scout
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                            <span><strong><a href="/scout-sports/baseball">Click here</a> to search for a SMWW Baseball Scout by Area. </strong><br/>
                            SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span></p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                    </div>
                    <div id="conferences-block" className="conferences-block">
                        <h2>UPCOMING CONFERENCES & EVENTS</h2>
                            <div className="view-conferences">                       
                                <ul className="colistitem">
                                {conferences.map((conf, index) => (
                                    <li
                                    key={index}
                                    className="views-row"
                                    >
                                    <div className="views-field">
                                        <div className="desktop_conference_tile">
                                        <div className="views-field-field-image">
                                            <a href={conf.link}>
                                            <img src={conf.image} alt={conf.title} />
                                            </a>
                                        </div>
                                        <div className="views-field-wrap">
                                            <div className="views-field-title">
                                            <a href={conf.link}>{conf.title}</a>
                                            </div>
                                            <div className="views-field-field-apply-form-desc intro">
                                            {conf.description}
                                            </div>
                                            <div className="views-field-field_location">
                                            <a href={`${configData.DRUPAL_DOMAIN_URL}/winter-baseball-meetings-career-conference`}>{conf.location}</a>
                                            </div>
                                        </div>
                                     <div className="views-field views-field-field-registration-deadline-day"> 
                                        <div className="rdt">
                                            <span className="a1">{conf.month}</span>
                                            <span className="a2">
                                            {conf.day}
                                            <span className="view-field-year">{conf.year}</span>
                                            </span>
                                            <span className="a3">Conference</span>
                                            <span className="a4">Start Date</span>
                                        </div>

                                        <div className="rbt">
                                            <a href={conf.link}>
                                            <span className="a1_conf">LEARN MORE</span>
                                            </a>
                                        </div>
                                        </div>
                                        </div>

                                        <div className="mobile_conference_tile">
                                       
                                        <div className="views-field-wrap">

                                        <div className="header_title_div">
                                            <div className="circle_image">
                                                <i>
                                                    <img src={conf.icon} alt="icon" />
                                                </i>
                                            </div>

                                            <div className="views-field-title title">
                                                <a href={conf.link}>{conf.title}</a>
                                            </div>
                                        </div>

                                        <div className="rdt">
                                            <div className="month_day">{conf.fullDate}</div>
                                            <div className="starts">{conf.location}</div>
                                            <div className="description">{conf.description}</div>

                                            <div style={{ paddingBottom: "8%", paddingTop: "8%" }}>
                                                <span className="learn-more-btn">
                                                    <a href={conf.link}>LEARN MORE</a>
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                        </div>
                                    </div>
                                    </li>
                                ))}
                                </ul>
                           
                        </div>
                        </div>
                    </div>
                </div>
                <div className="right">
                     <div id="block-views-testimonials-block" className="block block-views">
                    <h2>Testimonials:</h2>

                  <div className="">
                        <div className="view view-testimonials">
                        <div className="">
                            <div className="testimonial-wrapper">
                            <ul>
                                {testimonialsData.map((testimonial) => (
                                <li
                                    key={testimonial.id}
                                    className="views-row"
                                >
                                    <div className="desktop_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyloaded"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            style={{ width: "100px", height: "100px" }}
                                        />
                                        </div>
                                    </div>

                                    <div className="views-field views-field-title title">
                                        <span className="field-content">
                                        <a href={testimonial.link}>{testimonial.name}</a>
                                        </span>
                                    </div>

                                    <div className="views-field views-field-field-author-title text">
                                        <div className="field-content">{testimonial.title}</div>
                                    </div>

                                    <div className="views-field views-field-body">
                                        <div className="field-content">
                                        <p>{testimonial.body}</p>
                                        </div>
                                    </div>
                                    </div>

                                   

                                    <div className="mobile_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyload testimonial_mobile_image"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                        />
                                        </div>
                                    </div>

                                    <div className="testimonial_wrapper_mobile">
                                        <div className="testimonial_left_content">
                                        <div className="testimonial_title">
                                            <a href={testimonial.link}>{testimonial.name}</a>
                                        </div>
                                        <br />
                                        <div className="testimonial_tag_line">
                                            {testimonial.title}
                                        </div>
                                        </div>
                                        <div className="testimonial_right_content">
                                        <div className="testimonial_body_content">
                                            <p>{testimonial.body}</p>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                ))}
                              
                            </ul>
                            </div>
                        </div>
                        </div>
                    </div>
                   

                    </div>
                      {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                     {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default ScoutEducationProgarm;